import { connect } from "react-redux";
import _ from "underscore";
var StudentsSelectedDisplay = require("components/org/roster/StudentsSelectedDisplay");

var ToggleMultiselect = require("components/utility/inputs/ToggleMultiselect");
var HelpSectionLink = require('components/utility/HelpSectionLink');
var LoadingButton = require("components/utility/LoadingButton");
var StudentDisplay = require("components/users/students/StudentDisplay");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

require("org/roster/roster_add_to_student_list.scss");

@connect(
  (state, props) => ({
    studentLists: RosterSelectors.studentLists({ state })
  }),
  (dispatch, props) => ({
    updateStudents: (updates, studentIDs) => {
      return dispatch(RosterActions.updateStudents({
        studentIDs,
        updates,
        embeds: ["student.student_list_ids", "student.prefs"]
      }))
    },
  })
)
class RosterEditStudentLists extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    this.state = this.getInitialState()
  }

  //////// HELPERS ////////
  getInitialState() {
    return { showStudents: false, overrides: {}, loading: false };
  }

  editStudentForm(key, val, callback) {
    this.setState({
      overrides: { ...this.state.overrides, [key]: val }
    }, callback)
  }

  showSuccessAlert() {
    window.wrNotifications.triggerDropDownNotification({
      title: "Classes Edited", icon: "ok-sign"
    }, 4000);
  }

  showErrorAlert() {
    window.wrNotifications.triggerDropDownNotification({
      title: "Oops!", text: "Something went wrong and the class was not edited",
      type: "error", icon: "remove"
    }, 4000);
  }

  editAlertText(studentsEdited) {
    if (studentsEdited == 'all' && _.has(this.state.overrides.all, 'primary')) {
      return "Are you sure you want to modify the classes for all selected students? This will override the current class rosters."
    } else if (studentsEdited == 'all' && !_.has(this.state.overrides.all, 'primary')) { 
      return "Are you sure you want to modify the classes for all selected students? This will add them all to a secondary class and they will remain in their primary classes."
    } else {
      return `Are you sure you want to modify the classes for ${studentsEdited} students? This will override the current class rosters.`
    } 
  }

  //////// SUBMIT ////////
  onSubmit(e) {
    $wr.nope(e);

    if (_.has(this.state.overrides, 'all')) {
      if (confirm(this.editAlertText('all'))) {
        this.setState({ loading: true })
        // modify all students
        var updates = { ...this.state.overrides }
        var studentIDs = _.compact(_.flatten(_.pluck(this.props.students, 'id')))
        this.updateStudents(updates, studentIDs)
      }
    } else if (_.isEmpty(this.state.overrides)) {
      window.wrNotifications.triggerDropDownNotification({
        title: "Modify a class before saving", icon: "exclamation-sign", type: "error"
      });
    } else {
      var studentsEdited = Object.keys(this.state.overrides).length
      if (confirm(this.editAlertText(studentsEdited))) {
        this.setState({ loading: true })
        // modify some students
        this.updateStudents(this.state.overrides, _.keys(this.state.overrides))
      }
    }
  }

  updateStudents(updates, studentIDs) {
    this.props.updateStudents(updates, studentIDs).then(() => {
      this.setState({ loading: false })
      // close modal
      this.props.onComplete()
      this.showSuccessAlert()
      // this.props.fetchStudents(true)
    }).catch(() => {
      this.setState({ loading: false })
      this.showErrorAlert()
    })
  }

  //////// RENDER METHOD ////////

  // START STUDENT ROW //
  renderStudentListSelector(student) {
    var topContent = (
      <div>
        Click a class to set it as primary.<br />
        Hold shift & click to set secondary.{" "}
        <HelpSectionLink featureName="Primary & Secondary Classes" linkSuffix="360054128371" iconOnly />
      </div>
    )

    const toggles = [
      {
        key: "primary",
        icon: "star",
        select: ToggleMultiselect.SELECT_LEFT_CLICK,
        primary: true
      }, {
        key: "secondary",
        icon: "star-empty",
        select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK,
      }
    ]

    var options = this.props.studentLists.map(x => ({ key: x.id, text: x.name }));
    var selected = {}

    if (student === 'all') {
      var studentLists = _.has(this.state.overrides, 'all') ? this.state.overrides['all'] : {}
    } else if (_.has(this.state.overrides, student.id)) {
      var studentLists = this.state.overrides[student.id]
    } else {
      var studentLists = student.student_list_ids
    }

    if (studentLists && studentLists.active) {
      _.each(studentLists.active, slID => {
        selected[slID] = slID === studentLists.primary ? "primary" : "secondary"
      })
    }

    var onClassChange = (updatedSelected) => {
      if (student === 'all') {
        var studentID = 'all'
        var newStudentListIDs = { 'active': [], 'all': [] }
      } else {
        var studentID = student.id
        var newStudentListIDs = {
          'active': [],
          'all': _.difference(student.student_list_ids.all, student.student_list_ids.active)
        }
      }
      _.each(updatedSelected, (toggleKey, studentListID) => {
        newStudentListIDs.active.push(parseInt(studentListID));
        newStudentListIDs.all.push(parseInt(studentListID));

        if (toggleKey === "primary") {
          newStudentListIDs.primary = parseInt(studentListID);
        }
      })
      this.editStudentForm(studentID, newStudentListIDs);
    }

    return (
      <ToggleMultiselect className="classSelector" dropdownDisplay="link"
        topContent={topContent}
        selected={selected}
        toggles={toggles}
        options={options}
        onChange={onClassChange} />
    )
  }

  allStudentDisplay() {
    if (this.props.students) {
      return (
        <div className='studentRow'>
          <div className='allStudentColumn'>
            <StudentsSelectedDisplay totalStudents={this.props.totalStudentCount} studentsSelected={this.props.students} hideTo />
          </div>
          <div className='studentListColumn'>
            {this.renderStudentListSelector('all')}
          </div>
        </div>
      )
    }
  }

  handleShowStudentClick() {
    this.setState({ showStudents: !this.state.showStudents })
  }

  renderStudentRows() {
    if (this.state.showStudents) {
      var showClass = 'showStudents'
      var linkText = 'Hide Student View'

    } else {
      var showClass = 'hideStudents'
      var linkText = 'Show Student View'
    }

    var displayToggle = (
      <div className='displayToggle'>
        <a onClick={this.handleShowStudentClick}>{linkText}</a>
      </div>
    )

    var studentDisplays = _.map(this.props.students, (student) => {
      return (
        <div className='studentRow' key={'student-' + student.id}>
          <div className='studentColumn'>
            <StudentDisplay studentID={student.id} showAvatar avatarMaxWidth={50} />
          </div>
          <div className='studentListColumn'>
            {this.renderStudentListSelector(student)}
          </div>
        </div>
      )
    })


    return (
      <div className='studentRowsContainer'>
        <div className="section studentTitle">
          <p className="title">Students</p>
        </div>
        <div className="section classTitle">
          <p className="title">Class</p>
        </div>
        {this.allStudentDisplay()}
        <div className={'studentRowContainer ' + showClass}>
          {studentDisplays}
        </div>
        {displayToggle}
      </div>
    )
  }

  // END STUDENT ROW //

  renderSubmitButton() {
    return (
      <div className="buttonContainer">
        <LoadingButton type="submit"
          loading={this.state.loading}
          text="Edit Classes"
          className="btn buttonSuccess"
          onClick={this.onSubmit} />
      </div>
    )
  }

  render() {
    const modalBody = (
      <div className="rosterEditStudentLists">
        {this.renderStudentRows()}
        {this.renderSubmitButton()}
      </div>
    )
    return (
      <div className="modal-body">
        {modalBody}
      </div>
    );
  }
};


RosterEditStudentLists.WrappedComponent.propTypes = StrictPropTypes({
  // From above
  studentLists: PropTypes.array,

  students: PropTypes.array,
  onComplete: PropTypes.func,
  totalStudentCount: PropTypes.number,

  // Handlers from @connect
  assignSubgroup: PropTypes.func,
  updateStudents: PropTypes.func,
});

module.exports = RosterEditStudentLists;



// WEBPACK FOOTER //
// ./modules/components/org/roster/RosterEditStudentLists.js